module.exports = __webpack_public_path__ + "img/icon-legislated-events.5cfa2659.svg";